import { render, staticRenderFns } from "./DistributionHistory.vue?vue&type=template&id=4db4dba2&scoped=true&"
import script from "./DistributionHistory.vue?vue&type=script&lang=js&"
export * from "./DistributionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DistributionHistory.vue?vue&type=style&index=0&id=4db4dba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4dba2",
  null
  
)

export default component.exports